var map = {
	"./detail-config": 831,
	"./detail-config.js": 831,
	"./detailAudio": 1477,
	"./detailAudio.js": 1477,
	"./detailOtherFile": 1478,
	"./detailOtherFile.js": 1478,
	"./detailPicture": 1479,
	"./detailPicture.js": 1479,
	"./detailVideo": 1054,
	"./detailVideo.js": 1054
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4693;